import { render, staticRenderFns } from "./VoteGian.vue?vue&type=template&id=4961d3ac&"
import script from "./VoteGian.vue?vue&type=script&lang=js&"
export * from "./VoteGian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports